import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import MarkdownContent from "@root/components/markdown/markdown";

interface CitationModalProps {
  isOpen: boolean;
  onClose: () => void;
  citedContext: string;
}

export const CitationModal: React.FC<CitationModalProps> = ({
  isOpen,
  onClose,
  citedContext,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent bg="white" borderRadius="12px" maxH="90vh" maxW="800px">
        <ModalHeader>
          <Text fontSize="20px" fontWeight="600" color="#1A202C">
            {t("legalCompliance.citedTextReference")}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody pt={2} pb={6} overflowY="auto">
          {citedContext ? (
            <MarkdownContent
              content={citedContext}
              p={0}
              styleCitations={true}
            />
          ) : (
            <Text fontSize="14px" color="#6B7280">
              {t("legalCompliance.citedTextPlaceholder")}
            </Text>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
